import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import SbEditable from 'storyblok-react';

import Image from '~/components/Dynamic/Image';
import IconLink from '~/components/IconLink';
import renderLink from '~/utils/render-link';

export default function Grid1({ blok }) {
  if (!blok.gridItem[0].textCard.length) return null;
  const [item1, item2, item3] = blok?.gridItem[0]?.textCard;

  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className="my-20 md:my-28">
        <div className="container">
          <div className="flex-wrap md:flex">
            <div className="grid gap-5 md:grid-rows-none md:grid-cols-12">
              <Link to={renderLink(item1?.button[0]?.button?.cached_url || '#')} className="relative flex flex-col justify-end flex-auto row-span-2 p-5 group md:p-8 md:row-span-5 md:col-span-7">
                <div className="absolute inset-0 overflow-hidden">
                  <Image blok={item1.icon} className="object-cover w-full h-full transition-transform duration-700 ease-in-out transform group-hover:scale-105" />
                </div>

                <div className="relative mt-20 mb-1 text-white font-heading md:mb-0">
                  <h5 className="font-bold uppercase text-15px ">{item1.subHeading}</h5>
                  <h3 className="mt-3 font-bold text-30px" dangerouslySetInnerHTML={{ __html: item1.heading }} />
                </div>
              </Link>


              <Link to={renderLink(item2?.button[0]?.button?.cached_url || '#')} className="relative flex flex-col flex-auto row-span-2 px-5 pb-10 group md:py-10 bg-lime md:px-8 col-span md:row-span-6 md:col-span-5">
                <div className="-ml-5 -mr-5 md:-mr-8 md:-ml-8">
                  <StaticImage src={`../../assets/images/home/hand-shake.png`} className="object-contain" alt="hand jug" />
                </div>
                <div className="flex-auto md:mt-10">
                  <h3 className="mt-3 mb-2 font-extrabold text-48px font-heading tracking-2 leading-[0.9em] ">
                    {item2.heading}
                  </h3>
                  <div className="text-20px tracking-tighter leading-[1.42em]">
                    <p>{item2.content}</p>
                  </div>

                  <IconLink type="button" color={'black'} className={`text-black font-heading font-extrabold mt-10 group-hover:opacity-50 transition-opacity duration-200`}>
                    {item2?.button[0]?.title}
                  </IconLink>
                </div>
              </Link>

              <Link to={renderLink(item3?.button[0]?.button?.cached_url || '#')} className="flex flex-col group md:col-span-7">
                <div className="h-auto p-6 bg-blue md:h-full md:flex md:flex-col md:justify-center">
                  <div className="flex flex-wrap items-center justify-center flex-auto -ml-4">
                    <div className="pl-4 my-1 font-extrabold tracking-wide text-white text-18px" dangerouslySetInnerHTML={{ __html: item3.heading }} />
                    <div className="pl-4 my-1">
                      <IconLink type="button" color={'white'} className="transition-opacity duration-200 group-hover:opacity-50">
                        {item3?.button[0]?.title}
                      </IconLink>
                    </div>
                  </div>
                </div>
              </Link>

            </div>

          </div>
        </div>
      </section>
    </SbEditable>
  );
}
